export const tr = {
    'ad-decline-req': 'Bu reklamlar, yayınlama kurallarına uygun olmadığından reddedildi.',
    'how-to-fix': 'Reklamınızın nasıl düzeltileceğini "Durum" sütunundan öğrenebilirsiniz.',
    'many-banner-title': 'Moderasyonu geçmeleri için {count} reklamı değiştirin',
    'one-banner-title': 'Moderasyonu geçmesi için {count} reklamı değiştirin',
    'one-banner-title-hint': 'Reklam, moderasyondan geçmediği için bu öneri gösterilmektedir',
    'open-ad-list':
        'Reklamınızın reddedilme nedenlerini öğrenmek ve bunları düzeltmek için reklamlarınızın tasarımını ve içeriğini kontrol edin.',
    'popup-ad-decline-req': 'Reklam, yayınlama kurallarına uygun olmadığından reddedildi.',
    'several-banner-title-hint': 'Bazı reklamlar moderasyondan geçmediği için bu öneri gösterilmektedir',
    'show-many-banner-button': '{count} reklamı görüntüle',
    'show-one-banner-button': '{count} reklamı görüntüle',
    'show-some-banner-button': '{count} reklamı görüntüle',
    'simple-title': 'Moderasyonu geçmesi için reklamı değiştirin',
    'some-banner-title': 'Moderasyonu geçmeleri için {count} reklamı değiştirin',
    'twenty-one-banner-title': 'Moderasyonu geçmeleri için {count} reklamı değiştirin'
};
